























import Vue from 'vue';

// Types
import { WorkExperience } from '~/services/CandidateService';

// Components
import Card from '~/components/profile/cards/Card.vue';
import WorkExperienceListItem from '../components/WorkExperienceListItem.vue';
import WorkExperienceModal from '../modals/WorkExperienceModal.vue';
import { commonProps } from '~/utils/candidate';

export default Vue.extend({
    name: 'WorkExperience',
    components: {
        Card,
        WorkExperienceListItem,
        WorkExperienceModal,
    },
    props: {
        ...commonProps(),
    },
    data() {
        return {
            showModal: false,
        };
    },
    computed: {
        workExperiences(): WorkExperience[] {
            const we = this.candidate.workExperiences;
            we.sort((a, b) => {
                return b.start.getTime() - a.start.getTime();
            });
            return we;
        },
        hasNoWorkExperience(): boolean {
            return Boolean(this.candidate.workExperiences.length === 0);
        },
        cardTitle(): string {
            return this.hasNoWorkExperience
                ? this.$t('profile.workExperience.titleWhenEmpty').toString()
                : this.$t('profile.workExperience.title').toString();
        },
    },
});
